import { LoadingIndicator } from "designer/apps/orgs/orgs-styles";
import { GlideFC } from "lib/glide-fc";
import { styled } from "sharedUI/styles";

const CardLoadingContainer = styled.div`
    width: 450px;
    margin: 0px 8px 0px 40px;
    position: relative;
    align-self: center;
`;

export const CardLoading: GlideFC = _p => {
    return (
        <CardLoadingContainer>
            <LoadingIndicator />
        </CardLoadingContainer>
    );
};
